import React, { useEffect, useState } from "react"
import PropTypes from 'prop-types'
import CalcService from "src/services/calc-service"
import ParameterTable from "src/components/table/parameter-table"
import { DATE_TIME_FORMAT_SHOW, DATE_FORMAT } from "src/utils/constants"
import dayjs from "dayjs"
import { formatDateUtc } from "src/utils/date-format"


const ParameterCriteriosLiquidez = (props) => {
    const calcService = new CalcService()
    const [data, setData] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        calcService.loadEndpoint(props.endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))

            setData(list)
        })
    }

    const createRow = async () => {
        const body = {
            'DataReferencia': dayjs().format(DATE_FORMAT),
            'ParametroA': 0,
            'ParametroB':0,
            'ParametroC':0.00,
            'ParametroD':0,
            'ParametroE':0
        }

        props.loading(true)
        return calcService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const { ID, DataReferencia, ParametroA, ParametroB, ParametroC, ParametroD, ParametroE } = newRow

        const body = {
            'DataReferencia': DataReferencia,
            'ParametroA': ParametroA,
            'ParametroB': ParametroB,
            'ParametroC': ParametroC,
            'ParametroD': ParametroD,
            'ParametroE': ParametroE,
            
        }

        props.loading(true)
        return calcService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        const { ID } = row
        return calcService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            loadData()
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            flex: true,
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            flex: 1,
            editable: true,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => dayjs(params.value).format(DATE_FORMAT),
            valueParser: (newValue) => dayjs(newValue).format(DATE_FORMAT)
        },
        {
            field: 'ParametroA',
            headerName: 'ParametroA',
            flex: 1,
            minWidth: 100,
            editable: true
        },
        {
            field: 'ParametroB',
            headerName: 'ParametroB',
            flex: 1,
            minWidth: 100,
            editable: true
        },
        {
            field: 'ParametroC',
            headerName: 'ParametroC',
            flex: 1,
            minWidth: 100,
            editable: true
        },
        {
            field: 'ParametroD',
            headerName: 'ParametroD',
            flex: 1,
            minWidth: 100,
            editable: true
        },
        {
            field: 'ParametroE',
            headerName: 'ParametroE',
            flex: 1,
            minWidth: 100,
            editable: true
        },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            type: 'date',
            valueGetter: ({ value }) => value && dayjs(value).toDate(),
            valueFormatter: params => formatDateUtc(params.value, DATE_TIME_FORMAT_SHOW),
        }
    ]

    return (
        <div>
            <ParameterTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                loadData={loadData} />
        </div>
    )
}

ParameterCriteriosLiquidez.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
}

export default ParameterCriteriosLiquidez
